import { useEffect, useMemo, useState } from 'react'
import {
  useRootDomainId,
  useAppDispatch,
  useDomainQueryParams,
} from 'app/hooks'
import AuthorizedRoutes from 'components/Routes/AuthorizedRoutes'
import { logOutThunk } from 'features/auth/login/slice'
import { LoaderOverlay } from 'components/Loader'
import { selectedNavTopDomainActions } from 'features/domains/slice'
import useUserTopDomains from 'features/auth/permissions/useUserTopDomains'
import { DomainType } from 'features/domains/types'
import { fetchMistOrganizationThunk } from 'features/networkAi/slice'

function SelectUserTopDomain() {
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState<boolean>(true)
  const [rootId] = useRootDomainId()

  const { userTopDomainsData, isFetching, error, isError } =
    useUserTopDomains(rootId)
  const firstTopDomain = userTopDomainsData?.[0]

  const domainQueryParams = useDomainQueryParams()
  const topDomainIdFromQuery = useMemo(
    () => domainQueryParams[0],
    [domainQueryParams]
  )
  const topDomainFromQuery = useMemo(() => {
    if (userTopDomainsData) {
      return userTopDomainsData.find(
        (topDomain) => topDomain.id === topDomainIdFromQuery
      )
    }
  }, [userTopDomainsData, topDomainIdFromQuery])

  useEffect(() => {
    const defaultTopDomain = topDomainFromQuery ?? firstTopDomain
    if (rootId && defaultTopDomain && !isFetching) {
      dispatch(
        selectedNavTopDomainActions.setNavTopDomain(
          defaultTopDomain as DomainType
        )
      )
      if (defaultTopDomain) {
        dispatch(
          fetchMistOrganizationThunk({
            rootId,
            body: { domainName: defaultTopDomain.name },
          })
        )
      }
      setLoading(false)
    }
  }, [dispatch, rootId, topDomainFromQuery, firstTopDomain, isFetching])

  useEffect(() => {
    if (isError) {
      setLoading(false)
      // TODO: instead of console msg show error screen and then logout
      console.log('Cant get user RMS Domains list!', error)
      // @ts-ignore - because RTK Query don't support string status type but in case of offline
      // we catch a fetch-internal string error message
      // and the goal was not to logout user when he gets offline but logout in all other cases
      if (error.status !== 'FETCH_ERROR') {
        dispatch(logOutThunk())
      }
    }
  }, [dispatch, isError, error])

  return <>{loading ? <LoaderOverlay isFullScreen /> : <AuthorizedRoutes />}</>
}

export default SelectUserTopDomain
